import { IActivo, IGeoJSONPoint, IReporteBase } from 'modelos/src';

/** Ambulancia con lo que hace falta para asignarla a una emergencia. */
export interface IMovilEmergencia extends IActivo {
  ultimoReporte?: IReporteBase<'Tracker 4G'>;
  /** Posición del último reporte. */
  posicion?: IGeoJSONPoint;
  /** Color de la comunicación: verde, amarillo, rojo o gris (sin reporte). */
  colorComunicacion: string;
  /** "Reportó hace 3 min", "Sin reportes". */
  textoComunicacion: string;
  /** Metros hasta el lugar de la emergencia (si ambos tienen posición). */
  distancia?: number;
  /** Código de la otra emergencia activa a la que está asignada. */
  asignadaA?: number;
  /** ng-select deshabilita los ítems con `disabled`. */
  disabled?: boolean;
}

export const COLOR_COMUNICACION = {
  reciente: '#2ECC71',
  demorada: '#F1C40F',
  sinComunicar: '#E74C3C',
  sinReporte: '#9e9e9e',
};

export function distanciaFormateada(distancia?: number): string {
  if (distancia === undefined || distancia === null) return '';
  return distancia >= 1000
    ? (distancia / 1000).toLocaleString('es-AR', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }) + ' km'
    : Math.round(distancia).toLocaleString('es-AR') + ' m';
}
